const registration = {
    links: {
        payment: 'Payment for already registered participants',
        participants: 'View registered participants',
        results2025: 'View 2025 results',
        results2026: 'View 2026 results',
    },
    notices: {
        testMode: 'TEST MODE: Payment uses a test price.',
        activeDiscount: 'Active registration fee discount code: {{discountPercent}}%',
        inactiveDiscount: 'The discount code is no longer active.',
        invalidDiscount: 'Invalid or inactive discount code.',
        discountUsesLeft: '{{count}} uses left for this discount code.',
        discountNoUsesLeft: 'This discount code has no uses left.',
        spacesLeft: '{{count}} registration spaces left.',
        checkingOpeningDate: 'Checking when registration opens...',
        registrationOpensOn: 'Registration will open on {{date}}.',
        registrationFull: 'The maximum number of participants has been reached. Registration is closed.',
        formHasErrors: 'Please fill in all required fields. If you have trouble, contact info@osogovo.run',
    },
    tiers: {
        title: 'Registration fee tiers',
        range: 'Participants {{from}}–{{to}}',
        fee: 'Fee for {{distance}} km: €{{amount}}',
        tShirt: 'T-shirt: €{{amount}}',
        tShirtUnavailable: 'T-shirt not available',
        current: '{{count}} registered',
    },
    countdown: {
        title: 'Race starts in',
        started: 'The race has started',
        days: 'days',
        hours: 'hours',
        minutes: 'min',
        seconds: 'sec',
    },
    fields: {
        distance: 'Distance',
        email: 'Email',
        emailPlaceholder: 'Enter a valid email',
        name: 'Full name',
        namePlaceholder: 'First and last name',
        phoneNumber: 'Phone number',
        phonePlaceholder: '+359 / 0898 / +1-234-567-8900',
        gender: 'Gender',
        genderMale: 'Male',
        genderFemale: 'Female',
        birth: 'Date of birth',
        country: 'Country',
        team: 'Team',
        itraId: 'ITRA ID',
        optional: '(optional)',
        discountCode: 'Discount code',
        discountCodePlaceholder: 'Enter a discount code',
        distance14: 'Osogovo Hut - 14 km',
        distance26: 'Ruen Peak - 27 km',
    },
    terms: 'By submitting this registration, I declare that I agree with the rules and terms of each race and will follow them. I participate voluntarily and at my own risk, releasing the organizers from liability.',
    tShirt: {
        label: 'Add official Osogovo Run running T-shirt (optional)',
        unavailableLabel: 'Ordering an official T-shirt is no longer available',
        imageAlt: 'Official T-shirt',
        add: 'Add T-shirt',
        remove: 'Remove T-shirt',
        addedCaption: 'T-shirt added (+{{price}} eur) - click to remove',
        addCaption: 'Add T-shirt (+{{price}} eur)',
        sizeLabel: 'Choose size',
        unavailable: 'Ordering a T-shirt is no longer available. You can proceed to payment without a T-shirt.',
        proceedWithout: 'Proceed to payment',
    },
    payment: {
        entryFee: 'Entry fee payment: {{amount}} eur.',
        discount: 'Entry fee discount: ({{discountPercent}}%): -{{amount}} eur.',
        tShirt: 'T-shirt: {{amount}} eur.',
        total: 'Total: {{amount}} eur.',
        currentTotal: 'Current total: {{amount}} eur.',
        freeRegistration: 'Registration is free with the applied discount code. Press the button to complete your registration.',
        redirectInfo: 'After validating your details, you will be redirected to the secure payment page.',
        confirmationInfo: 'Registration is confirmed after successful payment and server-side transaction verification.',
        redirecting: 'Redirecting...',
        finishFree: 'Complete registration',
        payAmount: 'Pay {{amount}} eur.',
    },
    paymentPages: {
        common: {
            home: 'Home page',
            toRegistration: 'Go to registration',
            toRegistrationDefinite: 'Back to registration',
            toParticipants: 'View participants',
            redirecting: 'Redirecting...',
        },
        request: {
            title: 'Retry Payment',
            instructions: 'Enter the email address you used for registration.',
            emailLabel: 'Email',
            emailPlaceholder: 'Enter a valid email',
            submit: 'Send payment link',
            submitting: 'Sending...',
            missingApi: 'API configuration is missing. Please try again later.',
            defaultMessage: 'If the email is already registered and payment was not successful, you will receive an email with a retry payment link. If you are not registered, please use the registration page.',
        },
        cancel: {
            title: 'Payment was not completed',
            defaultMessage: 'Your registration is saved as pending, but it is not confirmed. You can restart payment whenever you are ready.',
            payLaterEmailSent: 'Your registration is saved. We sent an email with bank transfer payment instructions. If needed: info@osogovo.run',
            pendingWithoutEmail: 'Your registration is saved as pending. If you do not receive payment instructions, write to info@osogovo.run',
            retryError: 'There was a problem restarting payment. Please try again.',
            retry: 'Try again',
        },
        success: {
            titles: {
                paid: 'Thank you for registering{{namePart}}!',
                pending: 'Payment is processing',
                cancelled: 'Payment was cancelled',
                missing: 'Payment information is missing',
                error: 'We could not confirm the payment',
                loading: 'Checking payment',
            },
            namePart: ', {{name}}',
            messages: {
                paid: 'Payment is confirmed and your registration is active. We look forward to seeing you at the start.',
                pending: 'The server is still waiting for final confirmation. Refresh the page after a few seconds.',
                cancelled: 'We did not receive a successful payment confirmation for this registration. You can try again.',
                missing: 'Open this page only after returning from the payment system, or start a new registration.',
                error: 'There was a problem checking the payment. If the amount was charged, contact info@osogovo.run.',
                loading: 'Please wait while we check the payment status.',
            },
            checkAgain: 'Check again',
        },
        retry: {
            missingEmail: 'Email address is missing. Please try again.',
            failedInit: 'There was a problem initializing payment. Please contact info@osogovo.run.',
            loadingTitle: 'Redirecting you to payment...',
            loadingSubMessage: 'Registration with an email address: ',
            loadingMessage: 'Please wait.',
            errorTitle: 'Something went wrong',
            toRegistered: 'Go to registered participants',
        },
    },
    errors: {
        required: 'Required field',
        invalidEmail: 'Invalid email format',
        invalidPhoneCharacters: 'Phone number may contain only digits, +, - and spaces',
        phoneTooShort: 'Phone number must be at least 8 characters',
        nameTooShort: 'Name must be at least 4 characters',
        fullNameRequired: 'First and last name are required',
        nameLatinOnly: 'Please enter your name using Latin letters',
        termsRequired: 'You must agree to the participation terms',
        tShirtSizeRequired: 'Choose a T-shirt size',
        missingPaymentConfiguration: 'Payment configuration is missing. Please contact info@osogovo.run.',
        emailAlreadyPaid: 'This email is already registered with confirmed payment. Please contact info@osogovo.run for more information.',
        paymentPending: 'This email is already registered, but payment is not complete. <a href="{{retryUrl}}">Try payment again</a> or <a href="mailto:info@osogovo.run">contact us</a>.',
        checkoutRedirectFailed: 'There was a problem redirecting to payment. Please try again later or contact info@osogovo.run.',
        registrationFull: 'The maximum number of participants has been reached. Registration is closed.',
    },
};

export default registration;
